import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueGtag from 'vue-gtag-next';
import { googleAnalyticsId } from './config/config';

import PrimeVue from 'primevue/config';
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

const app = createApp(App);
app.use(store).use(PrimeVue).use(router).use(VueGtag, {
  property: {
    id: googleAnalyticsId
  }
}).mount('#app');
